<template>
<div>
    <img class="logo-test" src="../../assets/logo.png">
    <br><br>
</div>
</template>

<script>
export default {

}
</script>

<style>
img {
    display: block;
    margin-left: auto;
    margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// Logo.vue?63b5478f